import React from "react";
import Box from "@mui/material/Box";

const STATUS_STYLES = {
  active: { label: "Active", border: "#52C41A", bg: "#F6FFED", dot: "#52C41A" },
  suspended: { label: "Suspended", border: "#FFA39E", bg: "#FFF1F0", dot: "#FF4D4F" },
  banned: { label: "Banned", border: "#CF1322", bg: "#FFF1F0", dot: "#CF1322" },
};

export const getPlatformStatusLabel = (status) => STATUS_STYLES[status]?.label || status;

export default function PlatformStatusChip({ status, withDot = true }) {
  const s = STATUS_STYLES[status] || { label: status || "Unknown", border: "#D5DCE1", bg: "#FFF", dot: "#93A1B0" };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        height: 24,
        px: "10px",
        borderRadius: 100,
        border: `1px solid ${s.border}`,
        background: s.bg,
        color: "#405261",
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        whiteSpace: "nowrap",
        flexShrink: 0,
        boxSizing: "border-box",
      }}
    >
      {withDot && (
        <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: s.dot, flexShrink: 0 }} />
      )}
      {s.label}
    </Box>
  );
}
